"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diff = exports.cmp = exports.neq = exports.eq = exports.lte = exports.lt = exports.gte = exports.gt = exports.rcompare = exports.compare = void 0;
const assert_1 = require("assert");
const goSemver = require("./go/semver");
const pseudoVersionRegExp = /(?:\.?0\.)?\d{14}-[0-9a-f]{8,32}$/i;
function compare(v, w) {
    // short-circuit for identical versions
    if (v === w) {
        return 0;
    }
    let pv, pw;
    try {
        pv = goSemver.parse(v);
        pw = goSemver.parse(w);
    }
    catch (e) {
        // semver.compare properly deals with either or both of the versions
        // being invalid
        return goSemver.compare(v, w);
    }
    // see: https://golang.org/cmd/go/#hdr-Pseudo_versions
    const vm = pv.prerelease.match(pseudoVersionRegExp);
    const wm = pw.prerelease.match(pseudoVersionRegExp);
    if (!vm && !wm) {
        // neither is a pseudo-version
        return goSemver.compareParsed(pv, pw);
    }
    if (vm) {
        pv.prerelease = pv.prerelease.substring(0, vm.index);
        if (pv.prerelease === '-') {
            pv.prerelease = '';
        }
    }
    if (wm) {
        pw.prerelease = pw.prerelease.substring(0, wm.index);
        if (pw.prerelease === '-') {
            pw.prerelease = '';
        }
    }
    const c = goSemver.compareParsed(pv, pw);
    if (c !== 0) {
        return c;
    }
    // equal base versions, and at least one pseudo-version
    if (vm && wm) {
        // both pseudo-versions
        return vm[0] === wm[0] ? 0 : vm[0] < wm[0] ? -1 : +1;
    }
    else if (vm) {
        return isPseduoBefore(pv) ? -1 : +1;
    }
    else {
        (0, assert_1.strict)(wm);
        return isPseduoBefore(pw) ? +1 : -1;
    }
}
exports.compare = compare;
function isPseduoBefore(pv) {
    if (pv.minor === '0' && pv.patch === '0') {
        // vX.0.0-yyyymmddhhmmss-abcdefabcdef
        return false;
    }
    else if (pv.prerelease.substring(1)) {
        // vX.Y.Z-pre.0.yyyymmddhhmmss-abcdefabcdef
        return false;
    }
    else {
        // vX.Y.(Z+1)-0.yyyymmddhhmmss-abcdefabcdef
        return true;
    }
}
function rcompare(v1, v2) {
    return compare(v2, v1);
}
exports.rcompare = rcompare;
function gt(v1, v2) {
    return compare(v1, v2) > 0;
}
exports.gt = gt;
function gte(v1, v2) {
    return compare(v1, v2) >= 0;
}
exports.gte = gte;
function lt(v1, v2) {
    return compare(v1, v2) < 0;
}
exports.lt = lt;
function lte(v1, v2) {
    return compare(v1, v2) <= 0;
}
exports.lte = lte;
function eq(v1, v2) {
    return compare(v1, v2) === 0;
}
exports.eq = eq;
function neq(v1, v2) {
    return compare(v1, v2) !== 0;
}
exports.neq = neq;
function _strictEq(v1, v2) {
    try {
        const pv1 = goSemver.parse(v1);
        const pv2 = goSemver.parse(v2);
        return goSemver.compareParsed(pv1, pv2) === 0 && pv1.short === pv2.short;
    }
    catch (e) {
        return v1 === v2;
    }
}
function _strictNeq(v1, v2) {
    return !_strictEq(v1, v2);
}
function cmp(v1, comparator, v2) {
    switch (comparator) {
        case '>':
            return gt(v1, v2);
        case '>=':
            return gte(v1, v2);
        case '<':
            return lt(v1, v2);
        case '<=':
            return lte(v1, v2);
        case '==':
            return eq(v1, v2);
        case '!=':
            return neq(v1, v2);
        case '===':
            return _strictEq(v1, v2);
        case '!==':
            return _strictNeq(v1, v2);
        default:
            throw new Error(`Invalid comparator: ${comparator}`);
    }
}
exports.cmp = cmp;
function diff() {
    throw new Error('Not implemented');
}
exports.diff = diff;
//# sourceMappingURL=comparison.js.map